import { create } from "zustand";

interface ModalState {
  isUpdatePaymentModalOpen: boolean;
  openUpdatePaymentModal: () => void;
  closeUpdatePaymentModal: () => void;
}

export const useUpdatePaymentModalStore = create<ModalState>((set) => ({
  isUpdatePaymentModalOpen: false,
  openUpdatePaymentModal: () => set({ isUpdatePaymentModalOpen: true }),
  closeUpdatePaymentModal: () => set({ isUpdatePaymentModalOpen: false }),
}));
